<template>

</template>

<script>
export default {
  name: 'Alert',
  data () {
    return {
      channels: []
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
